import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/brand_home";

export default class BrandHome extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.scrollToTop();
  }
}
